/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;




/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash-compat/internal/isObjectLike.js
 ** module id = 128
 ** module chunks = 0
 **/